import type { Analysis } from "./sanityTypesManual"

export type Geotag = NonNullable<Analysis["geotags"]>[number]

export const GeotagType = {
  ADMIN_BOUNDARY: "adminBoundary",
  POINT: "point",
  POLYGON: "polygon",
} as const
export type GeotagType = (typeof GeotagType)[keyof typeof GeotagType]
